import { createFooterMapper } from '../../../utils/normalizeColumnDefs';
import { SALES_PERSON } from '../../fields';
import { SALES_PERSON_VIDEO_REPORT_ID } from './salesPersonVideoReportId';

const reportFooterColumnDefinition = [SALES_PERSON].map(createFooterMapper(SALES_PERSON_VIDEO_REPORT_ID));

export default reportFooterColumnDefinition;
